module.exports = __webpack_public_path__ + "static/img/grow5.2fde2ec1.png";